<template lang="pug">
  span.badge(v-bind:class="this.classes")
    | {{ percentage }}
</template>

<script>
import Percentage from 'percentage'
export default {
  props: {
    value: 0,
    precision: 1,
    classes: '',
  },
  computed: {
    percentage() {
      return Percentage(this.value, this.precision)
    }
  },
}
</script>